// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".demo-alert-container[data-v-255a0e75]{align-items:center;display:flex;height:100%;left:50%;position:absolute;top:0;transform:translateX(-50%);z-index:10000}.demo-alert[data-v-255a0e75]{align-items:center;background:#ff1300;color:#fff;display:flex;font-size:60%;justify-content:center;margin:auto;padding:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
